import { isNil } from 'lodash';

import { ICIAMToken, IPartialUserInfo, IResponseCompanyConnection, IResponseCompanyConnectRoles } from "@services/company.interface";
import { CookieKey, getCookie } from "mt-shared";
/**
 * Checks if the user has the permission to perform the action
 * @param companyConnection User's company connection
 * @param permission the permission to check
 * @returns Boolean value indicating if the permission is allowed
 */
export function isPermissionAllowed(companyConnection: IResponseCompanyConnection, permission: string): boolean {
  if (!companyConnection?.company_connection_user_roles) return false;

  // a user can have multiple roles, so we need to check all of them
  const allPermissions: string[] = companyConnection.company_connection_user_roles
    .flatMap((role: IResponseCompanyConnectRoles) => role.company_connection_user_role.user_role.permissions);

  return allPermissions.includes(permission);
}

export function getPartialUserInfo(): IPartialUserInfo {
  let userId: number | null = null;
  let userEmail: string | null = null;
  let userRole: string | null = null;
  let compositeFleetSize: number | null = null;
  let companyId: number | null = null;

  try {
    const token: ICIAMToken = getCookie(CookieKey.CIAM_AUTH_TOKEN);
    if (token) {
      userRole = token.roles ? token.roles?.[0] : '';
      companyId = token.fleet_company_id || null;
      userEmail = token.email || '';
      userId = token.sub || null;
      try {
        compositeFleetSize = JSON.parse(token?.['user_information'] || '{}')?.['customer_fleet_size'] || null;
      } catch (error) {
        console.log('Error parsing fleet size information from user info cookie', error);
      }
    }
    if (isNil(userId)) {
      userId = getCookie(CookieKey.USER_ID);
    }
    if (isNil(compositeFleetSize)) {
      const userInfoCookie = getCookie(CookieKey.USER_INFORMATION);
      if (userInfoCookie) {
        try {
          compositeFleetSize = JSON.parse(userInfoCookie)?.['customer_fleet_size'] || null;
        } catch (error) {
          console.log('Error parsing fleet size information from user info cookie', error);
        }
      }
    }
    userId = !isNil(userId) ? Number(userId) : null;
    compositeFleetSize = isNil(compositeFleetSize) ? Number(compositeFleetSize) : null;
    companyId = !isNil(companyId) ? Number(companyId) : null;
  } catch (error) {
    console.log('Error retrieving user info from cookies:', error);
  }

  return {
    userId,
    userEmail,
    userRole,
    compositeFleetSize,
    companyId,
  };
}